<template>
	<svg xmlns="http://www.w3.org/2000/svg" class="icon">
		<use :href="href" />
	</svg>
</template>

<script>
import icons from '@/assets/icons.svg'

export default {
	name: 'Icon',
	props: {
		name: String
	},
	computed: {
		href() {
			return `${icons}#icon_${this.name}`
		}
	}
}
</script>

<style lang="scss" scoped>
.icon {
	width: 100%;
	height: 100%;
}
</style>
